module.exports = __webpack_public_path__ + "static/media/Mandibuzz_gaussian2.6422976e.png";